import { Component, Input } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
import { KnittingOrder } from '../../../../models/production/knitting-order';

@Component({
  selector: 'app-relation-knittings-modal',
  templateUrl: './relation-knittings-modal.component.html',
  styleUrl: './relation-knittings-modal.component.scss',
})
export class RelationKnittingsModalComponent extends BaseModalComponent<KnittingOrder[] | null> {
  @Input() public knittings: KnittingOrder[] = [];
  onClose() {
    this.close({ action: 'close', data: null });
  }
}
